import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const SurveySubmitNode = memo((props: NodeProps) => {
  return (
    <BaseNode
      {...props}
      icon="✅"
      label="Finalizar Pesquisa"
      color="#10b981"
      description="Envia e encerra a pesquisa"
      onDelete={props.data.onDelete}
    />
  );
});

SurveySubmitNode.displayName = 'SurveySubmitNode';
